
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer une carte de visite de coach sportif ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Lancez votre activité de coach sportif avec une carte de visite percutante. Suivez nos conseils et astuces pour marquer les esprits de manière professionnelle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer une carte de visite de coach sportif ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous lancez votre activité de coach sportif ? Cet article vous donne des conseils et astuces pour créer votre plus belle carte de visite !",
        },
      ],
    };
  },
};
